import styled from 'styled-components';
import { setRem } from '../../utils/styles';
import { motion } from 'framer-motion';

export const Wrapper = styled(motion.div)`
  padding: 0 ${setRem(50)} ${setRem(50)};
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  padding: ${setRem(25)} ${setRem(50)};
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const TourContainer = styled.div`
  position: relative;
  z-index: 11;

  &::before {
    display: block;
    content: '';
    width: 100%;
    padding-top: calc((9 / 16) * 100%);
  }
`;

export const TourContent = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

export const BackBtn = styled.img`
  position: absolute;
  bottom: 50px;
  left: 50px;
  width: 40px;
  height: 40px;
  display: block;
  cursor: pointer;
`;
